import { render, staticRenderFns } from "./SnowSwitch.vue?vue&type=template&id=4abff720&scoped=true&"
import script from "./SnowSwitch.vue?vue&type=script&lang=js&"
export * from "./SnowSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SnowSwitch.vue?vue&type=style&index=0&id=4abff720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abff720",
  null
  
)

export default component.exports